<sc-flex vertical stretchContent fitHeight>
  <sc-flex-fitting-content vertical>
    <sc-padding fitHeight>
      <sc-scroll-pane>
        <app-transport-details [mode]="TransportDetailMode.READONLY" [layout]="layoutDefinition"
          [transport]="transportAssignmentSight.transport">
        </app-transport-details>
      </sc-scroll-pane>
    </sc-padding>
  </sc-flex-fitting-content>
  <div class="station-details" *ngIf="station != null">
    <sc-content-spacer vertical></sc-content-spacer>
    <sc-flex>
      {{ station.name}}
      <sc-content-spacer grow></sc-content-spacer>
      <sc-timer-label *ngIf="transportAssignmentSight.executionTimestamp != null"
        [date]="dateUtilsService.parseDateFromTimestamp(transportAssignmentSight.executionTimestamp)"></sc-timer-label>
    </sc-flex>
  </div>
</sc-flex>
